(() => {
  if (!document.body.classList.contains('template-index')) return;
  const instances = new Map();
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function mount(rail, label, slider = false) {
    if (instances.has(rail)) return;
    const controls = document.createElement('div');
    controls.className = 'ss-home-scroll-controls';
    const line = document.createElement('div');
    line.className = 'ss-home-scroll-line';
    line.setAttribute('aria-hidden', 'true');
    const thumb = document.createElement('span');
    thumb.className = 'ss-home-scroll-thumb';
    line.append(thumb);
    controls.append(line);
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ss-home-scroll-button';
      button.setAttribute('aria-label', `${direction < 0 ? 'Previous' : 'Next'} ${label}`);
      button.innerHTML = `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="${direction < 0 ? 'M19 12H5m6-6-6 6 6 6' : 'M5 12h14m-6-6 6 6-6 6'}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      button.addEventListener('click', () => {
        if (slider) {
          const section = rail.closest('.shopify-section');
          section?.querySelector(direction < 0 ? '.m-slider-controls__button-prev' : '.m-slider-controls__button-next')?.click();
        } else rail.scrollBy({ left: direction * rail.clientWidth * .8, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
      controls.append(button);
      return button;
    });
    const host = slider ? rail.closest('m-testimonials') : rail;
    if (slider) host.append(controls); else rail.after(controls);
    rail.classList.add('ss-home-scroll-rail');
    if (slider) host.classList.add('ss-home-slider-ready');
    let frame = 0;
    function update() {
      frame = 0;
      let ratio, progress, overflow;
      if (slider) {
        const slides = [...rail.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')];
        const active = rail.querySelector('.swiper-slide-active');
        const index = Number(active?.getAttribute('data-swiper-slide-index') || 0);
        ratio = 1 / Math.max(slides.length, 1);
        progress = index / Math.max(slides.length - 1, 1);
        overflow = slides.length > 1;
      } else {
        const range = rail.scrollWidth - rail.clientWidth;
        overflow = range > 2 && rail.clientWidth > 0;
        ratio = rail.clientWidth / Math.max(rail.scrollWidth, 1);
        progress = Math.max(0, Math.min(1, rail.scrollLeft / Math.max(range, 1)));
        buttons[0].disabled = progress <= .001;
        buttons[1].disabled = progress >= .999;
      }
      controls.hidden = !overflow;
      const width = Math.max(.06, Math.min(1, ratio)) * 100;
      thumb.style.width = `${width}%`;
      thumb.style.left = `${progress * (100 - width)}%`;
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    rail.addEventListener('scroll', schedule, { passive: true });
    const resize = new ResizeObserver(schedule);
    resize.observe(rail);
    const observer = new MutationObserver(schedule);
    observer.observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    update();
    instances.set(rail, () => { resize.disconnect(); observer.disconnect(); rail.removeEventListener('scroll', schedule); cancelAnimationFrame(frame); controls.remove(); instances.delete(rail); });
  }
  function init() {
    const selectors = [
      ['.m-blog-grid .m-mixed-layout__inner', 'articles']
    ];
    selectors.forEach(([selector, label]) => document.querySelectorAll(`#MainContent ${selector}`).forEach(rail => mount(rail, label)));
    document.querySelectorAll('#MainContent m-testimonials .swiper-container').forEach(rail => mount(rail, 'review', true));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => instances.forEach((cleanup, rail) => { if (event.target.contains(rail)) cleanup(); }));
})();
